"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListAndDetailViewEditor = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var Add_1 = __importDefault(require("@mui/icons-material/Add"));
function ListAndDetailViewEditor(props) {
    var _this = this;
    var _a = (0, react_1.useState)(), selectedId = _a[0], setSelectedId = _a[1];
    var _b = (0, react_1.useState)(false), createNew = _b[0], setCreateNew = _b[1];
    var noResult = props.list.NoResultElement;
    var result = props.list.result || [];
    var idExtractor = props.idExtractor;
    (0, react_1.useEffect)(function () {
        if (noResult !== null) {
            setCreateNew(true);
        }
        if (result && result.length > 0 && result.map(idExtractor).indexOf(selectedId) === -1) {
            setSelectedId(idExtractor(result[0]));
        }
    }, [noResult, result, selectedId, idExtractor]);
    var list = result || [];
    var selected = (result || []).filter(function (r) { return props.idExtractor(r) === selectedId; })[0];
    var _c = (0, react_1.useState)(''), search = _c[0], setSearch = _c[1];
    if (search !== '') {
        list = list.filter(function (o) { return props.searchFields(o).filter(function (v) { return v.indexOf(search) !== -1; }).length > 0; });
    }
    return (react_1.default.createElement(material_1.Grid, { container: true, spacing: 2, style: { height: '100%', width: '100%' } },
        react_1.default.createElement(material_1.Grid, { item: true, xs: 3 },
            react_1.default.createElement(material_1.Card, { style: { height: '100%', overflow: 'visible' } },
                react_1.default.createElement(material_1.Grid, { container: true, direction: "column", style: { height: '100%' } },
                    react_1.default.createElement(material_1.Grid, { item: true },
                        react_1.default.createElement("div", { style: { padding: 5 } },
                            react_1.default.createElement(material_1.TextField, { autoComplete: "off", fullWidth: true, label: "Search", name: "search", variant: "outlined", value: search, onChange: function (e) { return setSearch(e.target.value); } }))),
                    react_1.default.createElement(material_1.Grid, { item: true, xs: true },
                        react_1.default.createElement(material_1.List, null,
                            props.list.LoadingOrErrorElement,
                            list.map(function (c) { return (react_1.default.createElement(material_1.ListItem, { key: props.idExtractor(c), button: true, onClick: function () { return setSelectedId(props.idExtractor(c)); }, selected: selected === c && !createNew },
                                react_1.default.createElement(material_1.ListItemText, null, props.displayName(c)))); }),
                            props.list.NoResultElement === null && props.list.result && list.length === 0 && (react_1.default.createElement(material_1.Typography, { variant: "body2", color: "textSecondary", style: { textAlign: 'center' } }, "Nothing matches that search")),
                            props.list.NoResultElement)),
                    react_1.default.createElement(material_1.Grid, { item: true, style: { textAlign: 'right' } },
                        react_1.default.createElement("div", { style: { padding: 16 } },
                            react_1.default.createElement(material_1.Fab, { color: "primary", "aria-label": "add", onClick: function () { return setCreateNew(true); } },
                                react_1.default.createElement(Add_1.default, null))))))),
        react_1.default.createElement(material_1.Grid, { item: true, xs: 9 },
            react_1.default.createElement(material_1.Card, { style: { display: 'inline-block', padding: 16 } }, createNew
                ? props.create({
                    onCancel: function () {
                        setCreateNew(false);
                    },
                    onComplete: function (id) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, props.list.reload()];
                                case 1:
                                    _a.sent();
                                    setSelectedId(id);
                                    setCreateNew(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); },
                })
                : props.detail({
                    onReload: function () { return props.list.reload(); },
                    item: selected,
                })))));
}
exports.ListAndDetailViewEditor = ListAndDetailViewEditor;
